import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../../query/query-ids'
import type { Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import { saveElementalInAList } from '~~/src/api/elementals'

export function insetListOnElementalsLists(listId: string) {
  return (old?: Elemental | null) => {
    if (!old)
      return old
    if (!old.listIds)
      return
    return { ...old, listIds: [...old.listIds, listId] } as Elemental
  }
}
function revertElementalLists(listId: string) {
  return (old?: Elemental | null) => {
    if (!old)
      return old
    if (!old.listIds)
      return
    return { ...old, listIds: old.listIds.filter(id => id !== listId) } as Elemental
  }
}

export const useSaveElementalInAList = () => {
  const queryClient = useQueryClient()
  return useMutation<boolean | null, Error, { elementalType: ElementalTypeEnum; id: string; listId: string; orderIndex?: number; slug?: string }>({
    mutationKey: ['save-elemental-in-a-list'],
    mutationFn: async ({ id, listId, orderIndex }) => {
      return await saveElementalInAList(listId, id, orderIndex)
    },
    onMutate: async ({ elementalType, id, listId, slug }) => {
      queryClient.setQueriesData<Elemental | null>({
        queryKey: ['elemental', elementalType, id],
        exact: false,
      }, insetListOnElementalsLists(listId))
      if (slug) {
        queryClient.setQueriesData<Elemental | null>({
          queryKey: ['elemental', elementalType, slug],
          exact: false,
        }, insetListOnElementalsLists(listId))
      }
    },
    onError: (_, { elementalType, id, listId, slug }) => {
      queryClient.setQueriesData<Elemental | null>({
        queryKey: ['elemental', elementalType, id],
        exact: false,
      }, revertElementalLists(listId))
      if (slug) {
        queryClient.setQueriesData<Elemental | null>({
          queryKey: ['elemental', elementalType, slug],
          exact: false,
        }, revertElementalLists(listId))
      }
      queryClient.refetchQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, listId],
        exact: false,
      })
    },
    onSuccess: (_, { elementalType, listId }) => {
      queryClient.refetchQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
      queryClient.invalidateQueries({
        queryKey: [TanStackQueryIds.PROFILE_LIST_ELEMENTALS],
        exact: false,
        type: 'all',
      })
      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, listId],
        exact: false,
      })

      queryClient.invalidateQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, listId],
        exact: false,
        type: 'all',
      })
    },
  })
}
